<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <small class="label">
          Please list all components and ingredients, including additives, preservatives, diluents and
          processing aids
        </small>

<div v-for="(composition, index) in form.compositions" :key="index" class="mt-8">
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider :vid="index+'component_ingredient'" :name="index+'component_ingredient'"  rules="required" v-slot="{ errors }">
              <small class="label">Component / Ingredient</small>
              <vs-input type="text" name="component_ingredient" v-model="composition.component_ingredient" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider :vid="index+'source_botanical_name'" :name="index+'source_botanical_name'"  rules="" v-slot="{ errors }">
              <small class="label">Source / Botanical Name</small>
              <vs-input type="text" v-model="composition.source_botanical_name" name="source_botanical_name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
      </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider :vid="index+'percent_present'" :name="index+'percent_present'"  rules="required" v-slot="{ errors }">
              <small class="label">% Present</small>
              <vs-input type="text" v-model="composition.percent_present" name="percent_present" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider :vid="index+'country_processing'" :name="index+'country_processing'" rules="required" v-slot="{ errors }">
              <small class="label">Country of Processing</small>
              <v-select :filter-by="myFilter"  :clearable="false" name="country_processing" placeholder="" label="name" v-model="composition.country_processing" multiple :reduce="option => option.id" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider :vid="index+'country_harvest'" :name="index+'country_harvest'" rules="" v-slot="{ errors }">
              <small class="label">Country of Harvest</small>
              <v-select :filter-by="myFilter"  :clearable="false" name="country_harvest" placeholder="" label="name" v-model="composition.country_harvest" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider :vid="index+'function'" :name="index+'function'"  rules="" v-slot="{ errors }">
              <small class="label">Function</small>
              <vs-input type="text" v-model="composition.function" name="function" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Comment (Optional)
            </small>
            <vs-textarea v-model="composition.comment" />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-button :disabled="form.compositions.length < 2" class="float-right mt-0 mb-8" @click="deleteComposition(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x">delete</vs-button>
          </div>
        </div>

</div>

        <vs-button @click="addComposition" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Composition</vs-button>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import RawMaterialForm from "@/mixins/RawMaterialForm";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          compositions: [
            {component_ingredient: '', source_botanical_name: '', percent_present: '', country_processing: '',
              country_harvest: '',  function: '', comment: ''}
          ]
        },
        id: null,
        status: {},
        countryCodes: []
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_composition_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_composition_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialComposition(this.id, this.form))
          this.showSuccessMessage('Raw Material Composition Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialComposition(this.form))
          this.showSuccessMessage('Raw Material Composition Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadCountrCode() {
        const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes =  data
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialComposition(this.id)).data
        this.form.compositions =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      addComposition() {
        this.form.compositions.push(
          {component_ingredient: '', source_botanical_name: '', percent_present: '', country_processing: '',
            country_harvest: '',  function: '', comment: ''}
        )
      },
      deleteComposition(index) {
        this.form.compositions.splice(index, 1)
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      await this.loadCountrCode()
      if (this.status.is_raw_material_composition_complete) {
        await this.loadData()
      }
    },
    beforeDestroy() {
      this.onClickSubmit()
    }

  }
</script>

<style scoped>

</style>
